import React, { useRef, useState, useEffect } from "react";
import { useNavigate, Link, useParams } from "react-router-dom";
import "../../assets/css/login.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Password } from "primereact/password";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import axios from "axios";
import config from '../../config';
import { Dialog } from "primereact/dialog";
import successVideo from '../../assets/video/paperplane.mp4';
import crossVideo from '../../assets/video/cross.mp4';
import GifLoder from '../../components/GifLoder';
import { FcBrokenLink } from "react-icons/fc";
import CustomToast from '../../components/CustomToast';
import { useClientAuth } from '../../context/ClientAuthContext';
import { armOnboardingTrigger, startOnboardingChain } from '../../components/onboarding/onboardingStorage';

const PAN_PATTERN = /^[A-Z]{3}[ABCFGHLJPT][A-Z][0-9]{4}[A-Z]$/;
const ADDRESS_REGION_OPTIONS = [
  { label: "India", value: "india" },
  { label: "Outside India", value: "foreign" },
];

const Client_signup = () => {
  const { token } = useParams(); // Extract token from URL parameters
  const { login } = useClientAuth();
  const [value2, setValue2] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
  const [videocrosserrorDialogVisible, setVideocrosserrorDialogVisible] = useState(false); // New state for video dialog
  const [panTouched, setPanTouched] = useState(false);
  const [panWarningVisible, setPanWarningVisible] = useState(false);
  const [isActive, setIsActive] = useState(null); // Token validation status
  const [message, setMessage] = useState(""); // Response message
  const [formData, setFormData] = useState({
    CompanyName: "",
    email: "",
    password: "",
    confirmPassword: "",
    Billing_name: "",
    gstin: "",
    pan: "",
    poc: "",
    phone: "",
    bcc_emails: "",
    cc_emails: "",
    bill_address: "",
    addressRegion: "india",
  });

  const toastRef = useRef(null);
  const companyNameRef = useRef(null);
  const billingNameRef = useRef(null);

  const showMessage = (severity, detail) => {
    const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
    toastRef.current?.show(severity, summary, detail);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Enforce 120-character limit manually
    if (name === "bill_address" && value.length > 120) return;
    const normalizedValue = name === "pan"
      ? value.toUpperCase().replace(/\s/g, "").slice(0, 10)
      : value;
    setFormData((current) => ({ ...current, [name]: normalizedValue }));
  };

  const handleAddressRegionChange = (e) => {
    setFormData((current) => ({ ...current, addressRegion: e.value }));
    setPanTouched(false);
  };

  const handleBackStep = (e) => {
    e.preventDefault();
    setStep(1); // Move back to Step 1
  };


  const handleNextStep = (e) => {
    e.preventDefault();

    if (!formData.CompanyName.trim()) {
      showMessage("error", "Company Name is required");
      return;
    }
    if (!formData.email.trim()) {
      showMessage("error", "Email is required");
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim())) {
      showMessage("error", "Please enter a valid email address");
      return;
    }
    if (!formData.password.trim()) {
      showMessage("error", "Password is required");
      return;
    }
    if (!formData.confirmPassword.trim()) {
      showMessage("error", "Please confirm your password");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      showMessage("error", "Passwords do not match");
      return;
    }

    // Pre-fill the billing name for a faster second step, while preserving a value
    // the user may already have edited before navigating back.
    setFormData((current) => ({
      ...current,
      Billing_name: current.Billing_name.trim() || current.CompanyName.trim(),
    }));

    setStep(2); // ✅ Move to next step if all validations pass
  };


  const handleSubmit = async (e, confirmedWithoutPan = false) => {
    e?.preventDefault();
    const normalizedPan = formData.pan.trim().toUpperCase();
    const isIndiaAddress = formData.addressRegion === "india";

    // Client-side validation for Step 2 fields
    if (!formData.Billing_name.trim()) {
      showMessage("error", "Billing name is required");
      return;
    }
    if (isIndiaAddress && !normalizedPan) {
      setPanTouched(true);
      showMessage("error", "PAN is required for an Indian billing address. Enter a PAN or type NA if it is unavailable.");
      return;
    }
    if (normalizedPan && normalizedPan !== "NA" && !PAN_PATTERN.test(normalizedPan)) {
      setPanTouched(true);
      showMessage("error", "Enter a valid PAN in the format AAAAA9999A, or type NA if applicable.");
      return;
    }
    if (!formData.poc.trim()) {
      showMessage("error", "Contact Person name is required");
      return;
    }
    if (!value2) {
      showMessage("error", "Phone number is required");
      return;
    }
    if (!formData.bill_address.trim()) {
      showMessage("error", "Billing address is required");
      return;
    }

    if (isIndiaAddress && normalizedPan === "NA" && !confirmedWithoutPan) {
      setPanWarningVisible(true);
      return;
    }

    setPanWarningVisible(false);
    setLoading(true);

    const requestPayload = {
      ...formData,
      CompanyName: formData.CompanyName.trim(),
      Billing_name: formData.Billing_name.trim(),
      email: formData.email.trim(),
      pan: normalizedPan || "NA",
      poc: formData.poc.trim(),
      bill_address: formData.bill_address.trim(),
      addressRegion: formData.addressRegion,
      phone: value2, // Include phone number from InputNumber
    };

    try {
      const response = await axios.post(
        `${config.apiBASEURL}/ClientAuthRoutes/Client-register/${token}`,
        requestPayload
      );

      // Check if response status is 201
      if (response.status === 201) {
        setVideoDialogVisible(true); // Show video dialog

        setTimeout(() => {
          setVideoDialogVisible(false); // Hide video dialog after 6 seconds
          // Auto-login with the tokens Client-register now issues, and land the client
          // straight on Client_home — the onboarding form section (service tiles +
          // "Your Form Submissions") already lives there, so they can fill it out
          // immediately instead of being sent to a login screen first.
          login(response.data);

          // Arm the same guided product tour shown to returning clients on login, so a
          // brand-new registrant is walked through the dashboard too instead of only
          // ever seeing it if they happen to log out and back in.
          armOnboardingTrigger('client');
          startOnboardingChain();

          navigate("/Client/dashboard/Client_home");
        }, 4000);

      }
    } catch (error) {
      console.error("Error during registration:", error);
      // Previously this always showed a generic "Registration Failed" video with no
      // reason, so "link already used" / "link expired" / "email already exists" /
      // real server errors all looked identical. Surface the backend's actual reason.
      const backendMessage = error.response?.data?.message;
      const backendReason = error.response?.data?.reason;
      if (backendReason === 'expired' || backendReason === 'already_used' || backendReason === 'revoked' || backendReason === 'not_found') {
        // The link itself is no longer usable — re-run validation so the dedicated
        // "Link Validation Error" screen (with the specific reason) is shown instead
        // of letting the user re-submit a doomed form.
        setIsActive(false);
        setMessage(backendMessage || 'This registration link can no longer be used.');
        return;
      }
      showMessage("error", backendMessage || "Registration failed. Please check your details and try again.");
      setVideocrosserrorDialogVisible(true); // Show video dialog
      setTimeout(() => {
        setVideocrosserrorDialogVisible(false); // Hide video dialog after 6 seconds

      }, 5000);
    } finally {
      setLoading(false);
    }
  };


  // Token validation useEffect
  useEffect(() => {
    const validateToken = async () => {
      try {
        const response = await axios.post(`${config.apiBASEURL}/ClientAuthRoutes/validate-link`, {
          encryptedToken: token,
        });
        setIsActive(response.data.isActive);
        setMessage(response.data.message);
        console.log(response.data.message);
      } catch (error) {
        console.error("Error validating token:", error);
        setIsActive(false);
        setMessage("An error occurred while validating the link.");
      }
    };

    validateToken();
  }, [token]);

  useEffect(() => {
    if (!isActive) return undefined;

    const frameId = window.requestAnimationFrame(() => {
      const activeInput = step === 1 ? companyNameRef.current : billingNameRef.current;
      activeInput?.focus();
      activeInput?.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [isActive, step]);


  if (isActive === null) {
    return <div className="loderDiv">
      <GifLoder />
    </div>;
  }

  if (!isActive) {
    return (
      <Dialog visible={true} closable={false} header="Link Validation Error" style={{ width: '320px' }}>
        <div className="d-flex justify-content-center text-center align-items-center">
          <span style={{ fontSize: '70px', lineHeight: '1' }}><FcBrokenLink /></span>
          <p className="text-danger mb-0"><b>{message}</b></p>
        </div>
      </Dialog>
    );
  }

  const normalizedPanValue = formData.pan.trim().toUpperCase();
  const isIndiaAddress = formData.addressRegion === "india";
  const hasEnteredPan = normalizedPanValue && normalizedPanValue !== "NA";
  const panFormatIsValid = hasEnteredPan && PAN_PATTERN.test(normalizedPanValue);
  const panHasError = panTouched && (
    (isIndiaAddress && !normalizedPanValue) ||
    (hasEnteredPan && !panFormatIsValid)
  );


  return (
    <Container className="login-card clientlog">
      {/*className='login-card newyearcard'/*/}
      <Row className="mx-0 justify-content-start ps-0">
        <Col md={6} lg={5}>
          <Card title="Register">
            <div className="client-signup-progress" aria-label={`Registration step ${step} of 2`}>
              <div className="client-signup-progress-item is-active">
                <span className="client-signup-progress-number">1</span>
                <small>Account</small>
              </div>
              <span className={`client-signup-progress-line ${step === 2 ? "is-complete" : ""}`} />
              <div className={`client-signup-progress-item ${step === 2 ? "is-active" : ""}`}>
                <span className="client-signup-progress-number">2</span>
                <small>Company details</small>
              </div>
            </div>
            <form
              className="mt-4 client-signup-form"
              onSubmit={step === 1 ? handleNextStep : handleSubmit}
              noValidate
            >
              {/* First Step */}
              {step === 1 && (
                <div className="client-signup-step">
                  <Row className="m-0 h-auto ps-0">
                    <Col md={12} lg={12} className="mb-3 ps-0">
                      <span className="fnameinp">
                        <label htmlFor="firstName">
                          <i className="pi pi-user pe-2"></i>Company Name{" "}
                          <span>*</span>
                        </label>
                        <InputText
                          type="text"
                          name="CompanyName"
                          placeholder="Company Name"
                          value={formData.CompanyName}
                          onChange={handleInputChange}
                          ref={companyNameRef}
                          required
                        />
                      </span>
                    </Col>
                  </Row>
                  <Col md={12} lg={12} className="mb-3 p-0">
                    <span className="fnameinp">
                      <label htmlFor="email">
                        <i className="pi pi-envelope pe-2"></i>Email{" "}
                        <span>*</span>
                      </label>
                      <InputText
                        type="email"
                        name="email"
                        placeholder="example@test.com"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </span>
                  </Col>
                  <Col md={6} lg={12} className="mb-3 p-0 pe-1">
                    <label htmlFor="password">
                      <i className="pi pi-lock pe-2"></i>Password <span>*</span>
                    </label>
                    <Password
                      placeholder="Password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                      toggleMask
                      className="w-100 d-block position-relative"
                      required
                    />
                  </Col>
                  <Col md={6} lg={12} className="mb-3 p-0 ps-1">
                    <span className="fnameinp">
                      <label htmlFor="cpassword">
                        <i className="pi pi-lock pe-2"></i>Confirm Password{" "}
                        <span>*</span>
                      </label>
                      <InputText
                        type="password"
                        name="confirmPassword"
                        placeholder="***********"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        required
                      />
                    </span>
                  </Col>

                  <Col className="text-center mt-4">
                    <Button
                      label="Next"
                      icon="pi pi-arrow-right"
                      type="submit"
                      iconPos="right"
                      className="loginbtn d-flex"
                    />
                  </Col>
                </div>
              )}

              {/* Second Step */}
              {step === 2 && (
                <div className="client-signup-step">
                  <Row className="m-0 ps-0 client-signup-fields">
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>Billing Name{" "}
                        <span>*</span></label>
                      <InputText
                        name="Billing_name"
                        value={formData.Billing_name}
                        onChange={handleInputChange}
                        ref={billingNameRef}
                        required
                      />
                    </Col>
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label htmlFor="addressRegion">Billing Address Location <span>*</span></label>
                      <Dropdown
                        inputId="addressRegion"
                        name="addressRegion"
                        value={formData.addressRegion}
                        options={ADDRESS_REGION_OPTIONS}
                        onChange={handleAddressRegionChange}
                        optionLabel="label"
                        optionValue="value"
                        aria-label="Billing address location"
                      />
                    </Col>
                    <Col lg={6} md={6} className="mb-2 ps-lg-0">
                      <label>GSTIN</label>
                      <InputText
                        name="gstin"
                        value={formData.gstin}
                        onChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={6} md={6} className="mb-2 ps-lg-0">
                      <label htmlFor="pan">
                        PAN {isIndiaAddress
                          ? <span>*</span>
                          : <small className="text-muted fw-normal">(Optional)</small>}
                      </label>
                      <InputText
                        id="pan"
                        name="pan"
                        value={formData.pan}
                        onChange={handleInputChange}
                        onBlur={() => setPanTouched(true)}
                        placeholder={isIndiaAddress ? "AAAAA9999A or NA" : "Enter PAN if available"}
                        maxLength={10}
                        invalid={panHasError}
                        aria-invalid={panHasError}
                      />
                      {panTouched && normalizedPanValue === "NA" && (
                        <small className="client-signup-field-note text-warning">
                          PAN is marked as unavailable.
                        </small>
                      )}
                      {panTouched && hasEnteredPan && (
                        <small className={`client-signup-field-note ${panFormatIsValid ? "text-success" : "text-danger"}`}>
                          {panFormatIsValid ? "PAN format looks valid." : "Use PAN format AAAAA9999A."}
                        </small>
                      )}
                      {panTouched && isIndiaAddress && !normalizedPanValue && (
                        <small className="client-signup-field-note text-danger">
                          PAN is required. Type NA only when it is unavailable.
                        </small>
                      )}
                    </Col>
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>Contact Person{" "}
                        <span>*</span></label>
                      <InputText
                        name="poc"
                        value={formData.poc}
                        onChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>Phone No.{" "}
                        <span>*</span></label>
                      <InputNumber
                        value={value2}
                        onValueChange={(e) => setValue2(e.value)}
                        useGrouping={false}
                        className="w-100"
                      />
                    </Col>

                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>BCC Email</label>
                      <InputText
                        name="bcc_emails"
                        value={formData.bcc_emails}
                        onChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>CC Email</label>
                      <InputText
                        name="cc_emails"
                        value={formData.cc_emails}
                        onChange={handleInputChange}
                      />
                    </Col>
                    <Col lg={12} className="mb-2 ps-lg-0">
                      <label>Address{" "}
                        <span>*</span>
                      </label>
                      <InputTextarea
                        name="bill_address"
                        value={formData.bill_address}
                        onChange={handleInputChange}
                        rows={3}
                        maxLength={120} // Limits input to 120 characters
                        className="h-auto"
                      />
                      <p><small className='text-muted' style={{ fontSize: '11px' }}>{formData.bill_address.length}/120 characters</small></p>
                    </Col>
                  </Row>
                  <Col className="text-center mt-4 d-flex client-signup-actions">
                    <Button
                      label="Previous"
                      icon="pi pi-arrow-left"
                      type="button"
                      onClick={handleBackStep}
                      className="me-2 border-0"
                      severity="danger"
                      outlined
                    />
                    <Button
                      label={loading ? "Submitting..." : "Submit"}
                      icon={loading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                      type="submit"
                      className="loginbtn"
                      disabled={loading}
                    />
                  </Col>
                </div>
              )}
            </form>
            <p className="mt-4 text-center">
              Already have an account? <Link to="/CLient/login">Login</Link>
            </p>
          </Card>
        </Col>
      </Row>
      <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
        onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
        <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
        <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
      </Dialog>

      <Dialog visible={videocrosserrorDialogVisible} className='fadeInUp_dilog'
        onHide={() => setVideocrosserrorDialogVisible(false)} style={{ width: '320px' }} closable={false}>
        <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
        <h6 className="text-center mt-0 fadeInUp">Registration <span className='text-danger'>Failed</span></h6>
      </Dialog>
      <Dialog
        visible={panWarningVisible}
        onHide={() => setPanWarningVisible(false)}
        header="Proceed without PAN?"
        style={{ width: 'min(420px, 92vw)' }}
        closable={!loading}
        footer={
          <div className="d-flex justify-content-end gap-2">
            <Button
              label="Go back"
              type="button"
              severity="secondary"
              outlined
              disabled={loading}
              onClick={() => setPanWarningVisible(false)}
            />
            <Button
              label={loading ? "Submitting..." : "Proceed without PAN"}
              type="button"
              severity="warning"
              icon={loading ? "pi pi-spin pi-spinner" : "pi pi-exclamation-triangle"}
              disabled={loading}
              onClick={() => handleSubmit(null, true)}
            />
          </div>
        }
      >
        <p className="mb-0">
          You are registering an Indian billing address with PAN marked as NA.
          Do you wish to continue without providing a PAN?
        </p>
      </Dialog>
      <CustomToast ref={toastRef} />
    </Container>




  );
};

export default Client_signup;
